import { useEffect, useRef, useState } from "react";
import { getPhotoImageByNameRequest } from "../api/photo-api"

type Props = {
  thumb: string;
  onClick?: () => void;
};

const LazyImage = ({ thumb, onClick }: Props) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible || imageSrc) return;

    const fetchImage = async () => {
      try {
        const data = await getPhotoImageByNameRequest(thumb);
        const objectUrl = URL.createObjectURL(data);
        setImageSrc(objectUrl);
      } catch (err) {
        
      }
    };

    fetchImage();

    return () => {
      if (imageSrc) URL.revokeObjectURL(imageSrc);
    };
  }, [isVisible]);

  return (
    <div
      ref={containerRef}
      onClick={onClick}
      style={{
        cursor: "pointer",
        width: 130,
        height: 130,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {imageSrc ? (
        <img
          src={imageSrc}
          alt=""
          style={{ maxWidth: "130px", maxHeight: "130px", objectFit: "cover" }}
        />
      ) : (
        <p></p>
      )}
    </div>
  );
};

export default LazyImage;